import {Component, OnInit} from '@angular/core';
import {LangChange} from '../../../../../lang-change';
import {CollegeInfoService} from '../../../services/college-info.service';
import {Language} from '../../../../../common/models/language';
import {Utils} from '../../../../../common/services/Utils';
import {GraduateRegisterService} from '../../../../shared/services/graduate-register.service';
import {DictionaryService} from '../../../../shared/services/dictionary.service';
import {MatDialog} from '@angular/material';
import {RegisterGraduateActionDialogComponent} from '../register-graduate-action-dialog/register-graduate-action-dialog.component';
import {CommonService} from '../../../../shared/services/common.service';

declare const $;

@Component({
  templateUrl: './register-graduates.component.html',
  styleUrls: ['./register-graduates.component.scss']
})
export class RegisterGraduatesComponent extends LangChange implements OnInit {

  universityList: any[];
  centerProfessionList: any[];
  citizenshipList: any[];
  docStatusList: any[] = [];
  graduateDiplomaList: any[];
  selectedGraduateId: 0;
  langID: string;
  searchTypeList = ['BY_USER', 'BY_DOCUMENT'];
  params = {
    searchType: 'BY_USER',
    universityId: null,
    lastName: null,
    firstName: null,
    patronymic: null,
    iin: '911031351155',
    centerProfessionCode: null,
    dSeriesNumber: null,
    dFinishDocDate: null,
    advancedSearch: false,
    centerCitizenshipId: 113,
    dRegNumber: null,
    dDocStatus: false
  };
  graduateCount = 0;

  // captchaData = {captchaId: null, captchaCode: null, data: null};
  captchaData = null;
  Kazakhstan = 113;
  currentDate = new Date();

  constructor(private _universityInfoService: CollegeInfoService,
              private _dictionaryService: DictionaryService,
              private _utils: Utils,
              private _dialog: MatDialog,
              private _commonService: CommonService,
              private _registerService: GraduateRegisterService) {
    super(_utils._translateService);
    this.langID = Language.getCurrentLanguage().code;
    // this.params.collegeId = 13;
    this.params.lastName = 'Суяргулов';
    this.params.firstName = 'Динислам';
    this.params.iin = '';
    // this.params.iin = '921129449526';
  }

  ngOnInit() {
    this._universityInfoService.getNotCivilCollegeList().subscribe(list => {
      this.universityList = this._utils.translateListWithSort(list, 'name');
    });

    this._dictionaryService.getAllCenterProfessionList().subscribe(list => {
      this.centerProfessionList = this.translateProfessionList(list);
    });
    this._dictionaryService.getCitizenshipList().subscribe(list => {
      list = this._utils.translateListWithSort(list, 'name');
      this.citizenshipList = list;
    });

    this.docStatusList.push({id: false, name: this._utils._translateService.instant('register.original')});
    this.docStatusList.push({id: true, name: this._utils._translateService.instant('register.duplicate')});

    this._registerService.getAllGraduateCount().subscribe(count => {
      this.graduateCount = count;
    });

    this.reloadCaptcha();
  }

  translateProfessionList(list) {
    if (list && list.length) {
      for (let i = 0; i < list.length; i++) {
        list[i].fullName = list[i].code + ' ' + this._utils.getMultiValue(list[i], 'name');
      }
      return list.sort((a, b) => a.fullName.localeCompare(b.fullName));
    }
  }

  getKeys(map) {
    return Object.keys(map);
  }

  clearAllParams() {
    this.params = {
      searchType: this.params.searchType,
      universityId: 0,
      lastName: null,
      firstName: null,
      patronymic: null,
      iin: null,
      centerProfessionCode: null,
      dSeriesNumber: null,
      dFinishDocDate: null,
      advancedSearch: false,
      centerCitizenshipId: null,
      dRegNumber: null,
      dDocStatus: false
    };
    this.graduateDiplomaList = null;
  }

  reloadCaptcha() {
    this._commonService.getCaptcha().subscribe(data => {
      this.captchaData = data;
    });
  }

  onLangChange(language): void {
    this.langID = language['code'];
    this.universityList = this._utils.translateListWithSort(this.universityList, 'name');
    this.centerProfessionList = this.translateProfessionList(this.centerProfessionList);
    // this.citizenshipList = this._utils.translateListWithSort(this.citizenshipList, 'name');

  }

  searchList() {
    if (this.params.searchType === 'BY_USER') {
      if (!this.params.iin && !(this.params.firstName && this.params.firstName.length > 1 && this.params.lastName && this.params.lastName.length > 1)) {
        console.log('444');
        this._utils.notifyError('Введите ФИО выпускника', null);
        this.graduateDiplomaList = null;
        return;
      }

      if (this.params.iin && (this.params.iin + '').length != 12) {
        console.log('111');
        this._utils.notifyError('iin_input_error', null);
        this.graduateDiplomaList = null;
        return;
      }
    }

    this._registerService.findGraduateDiplomaList(this.params, this.captchaData).subscribe(resp => {
      this.graduateDiplomaList = null;
      this.reloadCaptcha();
      this._utils.checkMessage(resp, succ => {
        const list = resp.data;
        if (list && list.length) {
          this.selectedGraduateId = list[0].graduateId;
        }
        this.graduateDiplomaList = list;
      }, err => {
        this._utils.notifyMessage(resp, null, null);
      });

    });
  }

  clickCorrectGraduate(graduate) {
    if (graduate.enableCorrect) {
      const graduateDto = Object.assign({}, graduate);
      graduateDto.iin = graduateDto.iin || this.params.iin;
      graduateDto.type = 'UPDATE';
      const option = {
        message: 'register.msg_application_for_correcting_data_in_register',
        acceptMessage: 'common.continue',
        declineMessage: 'Cancel'
      };
      this.openDialog(option, graduateDto);
    }
  }

  clickInsertGraduate() {
    const graduateDto = {
      collegeId: this.params.universityId,
      lastName: this.params.lastName,
      firstName: this.params.firstName,
      patronymic: this.params.patronymic,
      centerProfessionCode: this.params.centerProfessionCode,
      iin: this.params.iin,
      type: 'INSERT'
    };

    const option = {
      message: 'register.msg_application_for_insert_data_in_register',
      acceptMessage: 'common.continue',
      declineMessage: 'Cancel'
    };
    this.openDialog(option, graduateDto);
  }

  private openDialog(option, dto) {
    this._utils.confirmDialog(option, ok => {
      this._dialog.closeAll();
      const dialogRef = this._dialog.open(RegisterGraduateActionDialogComponent, {
        width: '75%',
        minHeight: '450px',
        maxHeight: '99%',
        data: {
          graduateDto: dto,
          // citizenshipList: this.citizenshipList,
          universityList: this.universityList,
          centerProfessionList: this.centerProfessionList,
        }
      });

      dialogRef.afterClosed().subscribe(
        (result) => {
          if (result) {

          }
        }
      );
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/register/register-graduates/register-graduates.component.ts